import type { ComponentEntry } from '../../core/common-types'

const entry: ComponentEntry = {
	componentType: 'SiteStyles',
	loadComponent: () => import('./SiteStyles.js' /* webpackChunkName: "SiteStyles" */),
}

export default entry
